import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { SHOW_SNACKBAR } from "../utils/types";
import { generateTokenByApiKey } from "../api/login";
import { getEmailBody } from "../utils/helper";

const Contact = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);

    if (!name || !email || !phone || !subject || !message) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          type: "error",
          message: "Please fill all required fields",
          open: true,
        },
      });
      return;
    }

    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }


  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Support Centre
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Contact Us
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Dedicated Support to Make Your Experience Seamless
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="d-flex gap-5 flex-column">
                <div
                  className="d-flex align-items-start gap-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  <div className="icon d-block">
                    <i className="bi bi-telephone" />
                  </div>
                  <span>
                    {" "}
                    <span className="d-block">Phone</span>
                    <strong>+91 7081003111 (For Male Only)</strong><br></br>
                    <strong>+91 7081003222 (For Female Only)</strong><br></br>
                  </span>
                </div>
                <div
                  className="d-flex align-items-start gap-3"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="icon d-block">
                    <i className="bi bi-send" />
                  </div>
                  <span>
                    {" "}
                    <span className="d-block">Email</span>
                    <strong>support@vedanacare.com</strong>
                  </span>
                </div>
                <div
                  className="d-flex align-items-start gap-3"
                  data-aos="fade-up"
                  data-aos-delay={200}
                >
                  <div className="icon d-block">
                    <i className="bi bi-geo-alt" />
                  </div>
                  <span>
                    {" "}
                    <span className="d-block">Address</span>
                    <address className="fw-bold">
                      S-8/314 Hukulganj, Hukulganj, Varanasi, <br/>Uttar Pradesh, India - 221002
                    </address>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-wrapper max-md:mt-[50px]" data-aos="fade-up" data-aos-delay={300}>
                <form onSubmit={onSendEmail}>
                  <div className="row gap-3 mb-3">
                    <div className="col-md-12">
                      <label className="mb-2" htmlFor="name">
                        Full Name <strong className="text-red-600">*</strong>
                      </label>
                      <input
                        className="form-control"
                        id="name"
                        type="text"
                        value={notification?.name}
                        required=""
                        onChange={(e) => setNotification({ ...notification, name: e.target.value })}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="mb-2" htmlFor="email">
                        Email <strong className="text-red-600">*</strong>
                      </label>
                      <input
                        className="form-control"
                        id="email"
                        type="email"
                        value={notification?.email}
                        required=""
                        onChange={(e) => setNotification({ ...notification, email: e.target.value })}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="mb-2" htmlFor="phone">
                        Phone <strong className="text-red-600">*</strong>
                      </label>
                      <input
                        className="form-control"
                        id="phone"
                        type="tel"
                        value={notification?.phone}
                        required=""
                        onChange={(e) => setNotification({ ...notification, phone: e.target.value })}
                      />
                    </div>
                  </div>
                  <div className="row gap-3 mb-3">
                    <div className="col-md-12">
                      <label className="mb-2" htmlFor="subject">
                        Subject <strong className="text-red-600">*</strong>
                      </label>
                      <input
                        className="form-control"
                        id="subject"
                        type="text"
                        value={notification?.subject}
                        required=""
                        onChange={(e) => setNotification({ ...notification, subject: e.target.value })}
                      />
                    </div>
                  </div>
                  <div className="row gap-3 gap-md-0 mb-3">
                    <div className="col-md-12">
                      <label className="mb-2" htmlFor="message">
                        Message <strong className="text-red-600">*</strong>
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows={5}
                        value={notification?.message || ""}
                        required=""
                        onChange={(e) => setNotification({ ...notification, message: e.target.value })}
                      />
                    </div>
                  </div>
                  <button className="btn btn-primary fw-semibold" type="submit">
                    Send Message
                  </button>
                </form>
                <div className="mt-3 d-none alert alert-success" id="successMessage">
                  Message sent successfully!
                </div>
                <div className="mt-3 d-none alert alert-danger" id="errorMessage">
                  Message sending failed. Please try again later.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
